{{#each paths}}
export * from './{{this}}';
{{/each}}
